import { trpc } from "@blis/trpc/react";

import { Badge } from "@/components/ui/badge";
import { useAccession } from "../AccessionProvider";
import { InstrumentResultList } from "../InstrumentResults";
import { DetailSection } from "./Section";

export function InstrumentResultsSection() {
  const { accession } = useAccession();
  const instrumentResultSets = trpc.instrumentResults.list.useQuery({
    accessionId: accession.id,
    hours: 24,
  });

  const resultSets = instrumentResultSets.data || [];

  if (resultSets.length === 0) {
    return null;
  }

  return (
    <DetailSection
      title="Recent instrument results"
      hideBorder
      badge={<Badge size="sm">{resultSets.length}</Badge>}
    >
      <InstrumentResultList resultSets={resultSets} />
    </DetailSection>
  );
}
